module.exports = __webpack_public_path__ + "img/to.7f34961a.svg";